const o={cta:"cta"},s={dark:"dark"},a={left:"left",right:"right"},n={topLeft:"top-left",topCenter:"top-center",topRight:"top-right",bottomCenter:"bottom-center",bottomRight:"bottom-right"};export{a as labelAlignments,n as labelPositions,s as themes,o as variants};
//# sourceMappingURL=progress-bar.types.js.map
